<template>
    <ClicColInterno :cp="cp" :key="componentKey" :id="componentKey">
        <div>
            <b-link v-if="cp.props.visible" :href="cp.props.href" style="text-decoration: underline;"  @click="click()">{{ cp.props.text }}</b-link>
        </div>
    </ClicColInterno>
</template>

<script>

import ComponentInternalMixin from '../../core/ComponentInternalMixin';
import { BLink } from 'bootstrap-vue';

export default {
    name: 'ClicLink',
    mixins: [ComponentInternalMixin],
    components: { BLink },
    created() {
    },
    mounted() {
        console.log(this.props)
    },
    methods: {
        click() {
            if (this.lodash.has(this.cp, 'events.click')) {
                this._execEvent('click');
            }
        },

    }
}

</script>
